import React from 'react';
import { useRouter } from "next/router"
import Link from 'next/link'

const Footer = () => {
  const router = useRouter()
  
  return (
    <footer className="bg-white w-full border-t border-gray-200">
      {/* Main footer content */}
      <div className="px-6 py-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Left section - Links */}
          <div className="flex flex-wrap items-center gap-4 text-sm">
            <button 
              className="text-gray-500 hover:text-gray-700 transition-colors" 
              onClick={() => router.push("/privacy")}
            >
              Privacy Policy
            </button>
            <span className="text-gray-300">|</span>
            <button 
              className="text-gray-500 hover:text-gray-700 transition-colors"
              onClick={() => router.push("/cookies")}
            >
              Cookies
            </button>
            <span className="text-gray-300">|</span>
            <button 
              className="text-gray-500 hover:text-gray-700 transition-colors"
              onClick={() => window.location = 'mailto:bookingsupport@flexiblepowersystems.com?subject=from webapp: '}
            >
              Support
            </button>
          </div>

          {/* Cookie notice */}
          <div className="text-xs text-gray-500 text-center">
            This site only uses essential cookies
          </div>

          {/* Right section - Powered by */}
          <div 
            className="flex items-center space-x-1 text-sm cursor-pointer"
            onClick={() => window.location = 'https://flexiblepowersystems.com'}
          >
            <span className="text-gray-500">powered by</span>
            <span className="text-black font-semibold">
              Flexible Power Systems
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;